import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { operationsAPI } from '@/lib/api';
import {
  AlertTriangle, Clock, CalendarClock, ShieldCheck, Truck, FileWarning,
} from 'lucide-react';

const WIDGETS = [
  { key: 'needs_action_today',  label: 'Needs Action Today', icon: AlertTriangle, color: 'bg-red-50 text-red-700',     iconColor: 'text-red-500',     link: '/release-followups?bucket=today' },
  { key: 'pending_invitations', label: 'Pending Invitations', icon: Clock,        color: 'bg-amber-50 text-amber-700', iconColor: 'text-amber-500',   link: '/requests?status=Invitation_Sent_To_Agent' },
  { key: 'pending_release',     label: 'Pending Release',     icon: CalendarClock, color: 'bg-orange-50 text-orange-700', iconColor: 'text-orange-500', link: '/release-followups' },
  { key: 'missing_certifications', label: 'Missing Certs',   icon: ShieldCheck,  color: 'bg-fuchsia-50 text-fuchsia-700', iconColor: 'text-fuchsia-500', link: '/agents' },
  { key: 'carrier_delays',      label: 'Carrier Delays (>7d)', icon: Truck,       color: 'bg-violet-50 text-violet-700', iconColor: 'text-violet-500',  link: '/requests?status=Pending_Carrier' },
  { key: 'overdue_followups',   label: 'Overdue Follow-Ups',  icon: FileWarning,  color: 'bg-rose-50 text-rose-700',    iconColor: 'text-rose-500',    link: '/release-followups?bucket=overdue' },
];

export function ActionCenter() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    operationsAPI.actionCenter()
      .then(res => setData(res.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading || !data) return null;

  return (
    <Card data-testid="kr-action-center">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading font-semibold text-slate-900 text-base">KR Action Center</h3>
          <span className="text-xs text-slate-400">What needs your attention</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {WIDGETS.map(w => {
            const Icon = w.icon;
            const value = data[w.key] ?? 0;
            return (
              <Link
                key={w.key}
                to={w.link}
                className={`rounded-xl ${w.color} p-3 hover:shadow-md transition-shadow flex items-center justify-between gap-2`}
                data-testid={`action-center-${w.key}`}
              >
                <div>
                  <p className="text-2xl font-heading font-semibold">{value}</p>
                  <p className="text-[10px] uppercase tracking-wider opacity-80 mt-0.5 leading-tight">{w.label}</p>
                </div>
                <Icon size={22} className={`${w.iconColor} shrink-0`} />
              </Link>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}

export default ActionCenter;
